import api from 'src/lib/api/client';
import ApiError from 'src/lib/api/error';

const HistoryService = {
  async searchProductTrails({ params }) {
    try {
      const client = await api.getClient();
      return client.searchProductTrails(params);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },
};

export default HistoryService;
